import { SubmitButton } from 'components/common/buttons/SubmitButton';
import PdfForm from 'components/Pdf/PdfForm';
import { buildInvoiceGroups, getInvoiceGroupByConfig } from 'helpers/invoiceGrouping';
import ExcelJS from 'exceljs';
import React, { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { fetchGeneratedInvoices } from 'slices/invoiceSlice';
import { makeInvoice } from 'slices/invoiceSlice';
import { fetchAppointClients } from 'slices/invoiceSlice';
import { invoicesSelector } from 'slices/invoiceSlice';
import jsPDF from 'jspdf';
import moment from 'moment';

const PdfView = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const invoiceType = queryParams.get("type");

    const invoiceRef = useRef(null);
    const { appointClients, generatedInvoices, loader } = useSelector(invoicesSelector);
    const [invoiceNumber, setInvoiceNumber] = useState('');
    const [totalDueBill, setTotalDueBill] = useState(0);
    const [isInvoiceExist, setIsInvoiceExist] = useState(false);
    const [buttonLoader, setButtonLoader] = useState(false);
    const selectedDownloadFormat = useRef();

    const startDate = queryParams.get("start_date");
    const endDate = queryParams.get("end_date");
    const invoicingPeriod = queryParams.get("invoicing_period");

    console.log(generatedInvoices, "generatedInvoices");
    useEffect(() => {
        if (generatedInvoices?.length && invoiceNumber) {
            setIsInvoiceExist(!!generatedInvoices?.find(
                i => i.invoice_number?.trim().toLowerCase() === invoiceNumber.trim().toLowerCase()
            ));
        }
    }, [generatedInvoices, invoiceNumber]);

    const apptClient = appointClients?.find(t => t.id === Number(id));
    
    const generatedInvNo = generatedInvoices.map(i => i.invoice_number);

    // const generateInvoiceNumber = () => {
    //     let newInvoiceNumber;
    //     let counter = 1;
    //     do {
    //         newInvoiceNumber = `INV-${String(counter).padStart(3, '0')}`;
    //         counter++;
    //     } while (generatedInvNo.includes(newInvoiceNumber));

    //     return newInvoiceNumber;
    // };
    const generateInvoiceNumber = () => {
        if (!generatedInvoices?.length) return 'INV-001';

        const numbers = generatedInvoices
            .map(i => parseInt(i.invoice_number?.replace('INV-', '')))
            .filter(n => !isNaN(n));

        const max = Math.max(...numbers);

        return `INV-${String(max + 1).padStart(3, '0')}`;
    };

    useEffect(() => {
        const filters = {
            client_ids: id,
            ...(startDate && { start_date: startDate }),
            ...(endDate && { end_date: endDate }),
            ...(invoicingPeriod && { invoicing_period: invoicingPeriod }),
            ...(invoiceType && { type: invoiceType }),
        };

        dispatch(fetchAppointClients(1, filters));
        //  dispatch(fetchAppointClients(1,{client_ids:id}))
        setInvoiceNumber(generateInvoiceNumber());
    }, []);

    useEffect(() => {
        const totalBill = apptClient?.appointments?.reduce((sum, item) => sum + (item?.invoice?.total_amount || 0), 0).toFixed(2);
        setTotalDueBill(totalBill);
    }, [apptClient])

    const show = (value) => value !== null && value !== undefined && value !== '' && value !== 'N/A';

    const formatCurrency = (value) => {
        const numericValue = Number(value || 0);
        return Number.isFinite(numericValue) ? numericValue.toFixed(2) : '0.00';
    };

    const formatDate = (value) => {
        if (!value) return '';
        return new Date(value).toLocaleDateString('en-GB');
    };

    const getExceededTime = (scheduledDate, scheduledEnd, actualDate, actualEnd) => {
        if (!scheduledDate || !scheduledEnd || !actualDate || !actualEnd) return null;

        const scheduledEndMoment = moment(`${scheduledDate} ${scheduledEnd}`, 'YYYY-MM-DD HH:mm:ss');
        const actualEndMoment = moment(`${actualDate} ${actualEnd}`, 'YYYY-MM-DD HH:mm:ss');

        if (!scheduledEndMoment.isValid() || !actualEndMoment.isValid()) return null;

        const exceededSeconds = actualEndMoment.diff(scheduledEndMoment, 'seconds');
        if (exceededSeconds <= 0) return null;

        return moment.utc(exceededSeconds * 1000).format('HH:mm:ss');
    };

    const getFullDuration = (actualStartDate, actualStartTime, actualEndDate, actualEndTime) => {
        if (!actualStartDate || !actualStartTime || !actualEndDate || !actualEndTime) return null;

        const startMoment = moment(`${actualStartDate} ${actualStartTime}`, 'YYYY-MM-DD HH:mm:ss');
        const endMoment = moment(`${actualEndDate} ${actualEndTime}`, 'YYYY-MM-DD HH:mm:ss');

        if (!startMoment.isValid() || !endMoment.isValid()) return null;

        const durationMinutes = endMoment.diff(startMoment, 'minutes');
        const hours = Math.floor(durationMinutes / 60);
        const minutes = durationMinutes % 60;

        if (hours > 0 && minutes > 0) return `${hours} hour ${minutes} minute`;
        if (hours > 0) return `${hours} hour`;
        if (minutes > 0) return `${minutes} minute`;
        return '0 minute';
    };

    const renderActualStartTime = (checkinDate, checkinTime, checkoutDate, checkoutTime) => {
        if (!checkinTime || !checkinDate) return null;

        const crossesMidnight = checkoutDate &&
            moment(checkoutDate).format('YYYY-MM-DD') !== moment(checkinDate).format('YYYY-MM-DD');

        if (crossesMidnight) {
            return {
                label: 'Actual Start Date Time',
                value: `${moment(checkinDate).format('DD/MM/YYYY')} ${moment(checkinTime, 'HH:mm:ss').format('h:mm A')}`
            };
        }

        return {
            label: 'Actual Start Time',
            value: moment(checkinTime, 'HH:mm:ss').format('h:mm A'),
        };
    };

    // const handleGeneratePdf = () => {
    //     const doc = new jsPDF('p', 'pt', 'a4');

    //     doc.html(invoiceRef.current, {
    //         callback: function (doc) {
    //             doc.save(`${invoiceNumber}.pdf`);
    //         },
    //         margin: [7, 7, 7, 7],
    //         x: 7,
    //         y: 7,
    //         autoPaging: 'text',
    //         html2canvas: {
    //             scale: 0.73,
    //             useCORS: true
    //         }
    //     });
    // };

    // const handleGeneratePdf = () => {
    //     if (!invoiceNumber) {
    //         toast.error("Invoice number not found!", {
    //             className: "errorToast",
    //         });
    //         return;
    //     }

    //     setButtonLoader(true);

    //     const img = new Image();
    //     img.src = "/images/watermark.png";

    //     img.onload = () => {
    //         const doc = new jsPDF('p', 'pt', 'a4');

    //         doc.html(invoiceRef.current, {
    //             callback: function (doc) {
    //                 const totalPages = doc.internal.getNumberOfPages();
                    
    //                 const pageWidth = doc.internal.pageSize.getWidth();
    //                 const pageHeight = doc.internal.pageSize.getHeight();

    //                 const imgWidth = 300; 
    //                 const imgHeight = (img.naturalHeight / img.naturalWidth) * imgWidth || 150;

    //                 const x = (pageWidth - imgWidth) / 2;
    //                 const y = (pageHeight - imgHeight) / 2;

    //                 for (let i = 1; i <= totalPages; i++) {
    //                     doc.setPage(i);

    //                     // 1. Context State Save Karein
    //                     if (doc.saveGraphicsState) {
    //                         doc.saveGraphicsState();
    //                     }

    //                     // 2. Opacity Set Karein (0.15 = Light Faint Watermark)
    //                     if (doc.GState) {
    //                         doc.setGState(new doc.GState({ opacity: 0.15 }));
    //                     }

    //                     // 3. Add Image - img.src pass karne se Unknown Source Type Error nahi ayega
    //                     try {
    //                         doc.addImage(
    //                             img, 
    //                             'PNG',
    //                             x, 
    //                             y, 
    //                             imgWidth, 
    //                             imgHeight
    //                         );
    //                     } catch (err) {
    //                         console.error("Watermark render error:", err);
    //                     }

    //                     // 4. Context State Restore Karein (Is se Next Page Dark Nahi Hoga)
    //                     if (doc.restoreGraphicsState) {
    //                         doc.restoreGraphicsState();
    //                     }
    //                 }

    //                 doc.save(`${invoiceNumber}.pdf`);
                    
    //                 toast.success("Invoice downloaded successfully!", {
    //                     className: "successToast",
    //                 });
    //                 setButtonLoader(false);
    //             },

    //             margin: [7, 7, 7, 7],
    //             x: 7,
    //             y: 7,
    //             autoPaging: "text",

    //             html2canvas: {
    //                 scale: 0.73,
    //                 useCORS: true,
    //             }
    //         });
    //     };

    //     img.onerror = (err) => {
    //         console.error("Image load hone mein masla hua:", err);
    //         toast.error("Watermark logo load nahi ho saka!");
    //         setButtonLoader(false);
    //     };
    // };

    const handleGeneratePdf = (onComplete) => {
    if (!invoiceNumber) {
        toast.error("Invoice number not found!", {
            className: "errorToast",
        });
        return;
    }

    setButtonLoader(true);

    const img = new Image();
    img.src = "/images/watermark-dark.png";

    img.onload = () => {
        const doc = new jsPDF('p', 'pt', 'a4');

        doc.html(invoiceRef.current, {
            callback: function (doc) {
                const totalPages = doc.internal.getNumberOfPages();

                const pageWidth = doc.internal.pageSize.getWidth();
                const pageHeight = doc.internal.pageSize.getHeight();

                const imgWidth = 300;
                const imgHeight = (img.height / img.width) * imgWidth;

                const x = (pageWidth - imgWidth) / 2;
                const y = (pageHeight - imgHeight) / 2;

                for (let i = 1; i <= totalPages; i++) {
                    doc.setPage(i);

                    if (doc.saveGraphicsState) {
                        doc.saveGraphicsState();
                    }

                    if (doc.GState) {
                        doc.setGState(new doc.GState({ opacity: 0.15 }));
                    }

                    try {
                        doc.addImage(
                            img,
                            'PNG',
                            x,
                            y,
                            imgWidth,
                            imgHeight
                        );
                    } catch (err) {
                        console.error("Watermark render error:", err);
                    }

                    if (doc.restoreGraphicsState) {
                        doc.restoreGraphicsState();
                    }
                }

                doc.save(`${invoiceNumber}.pdf`);

                toast.success("Invoice downloaded successfully!", {
                    className: "successToast",
                });
                setButtonLoader(false);

                if (onComplete) onComplete();   // <-- yahan navigate call hoga
            },

            margin: [7, 7, 7, 7],
            x: 7,
            y: 7,
            autoPaging: "text",

            html2canvas: {
                scale: 0.73,
                useCORS: true,
            }
        });
    };

    img.onerror = (err) => {
        console.error("Image load hone mein masla hua:", err);
        toast.error("Watermark logo load nahi ho saka!");
        setButtonLoader(false);
    };
};

    const handleGenerateExcel = async (onComplete) => {
        try {
            const workbook = new ExcelJS.Workbook();
            workbook.creator = 'Mayabridge';
            const worksheet = workbook.addWorksheet('Invoice');
            worksheet.columns = [
                // { width: 14 },
                // { width: 42 },
                // { width: 24 },
                { width: 8 },
                { width: 26 },
                { width: 36 },
                { width: 18 },
            ];

            const logoResponse = await fetch('/main-logo.png');
            const logoData = await logoResponse.blob();
            const logoBase64 = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result.split(',')[1]);
                reader.onerror = reject;
                reader.readAsDataURL(logoData);
            });

            const logoId = workbook.addImage({ base64: logoBase64, extension: 'png' });
            worksheet.mergeCells('A1:D3');
            worksheet.addImage(logoId, {
                tl: { col: 1, row: 0.2 },
                br: { col: 3, row: 2.8 },
            });

            worksheet.getCell('A4').value = `INVOICE # ${invoiceNumber}`;
            worksheet.getCell('D4').value = `Date: ${formatDate(apptClient?.billing_date || new Date())}`;
            worksheet.getCell('A4').font = { bold: true, size: 12 };
            worksheet.getCell('D4').font = { bold: true, size: 12 };

            const isCompressedInvoice = invoiceType === 'compressed';

            if (isCompressedInvoice) {
                let currentRow = 5;

                const addSectionRow = (label, value, rowIndex) => {
                    worksheet.getCell(rowIndex, 1).value = label;
                    worksheet.getCell(rowIndex, 2).value = value;
                };

                worksheet.getCell(currentRow, 1).value = 'Bill To';
                worksheet.getCell(currentRow, 1).font = { bold: true, size: 12 };
                currentRow++;

                if (show(apptClient?.user?.name)) {
                    addSectionRow(apptClient.user.name, '', currentRow++);
                }

                if (show(apptClient?.billing_person)) {
                    addSectionRow(apptClient.billing_person, '', currentRow++);
                }

                if (show(apptClient?.billing_email)) {
                    addSectionRow(apptClient.billing_email, '', currentRow++);
                }

                if (show(apptClient?.billing_zipcode || apptClient?.city?.name)) {
                    addSectionRow(
                        `${apptClient?.billing_zipcode || ''} ${apptClient?.city?.name || ''}`.trim(),
                        '',
                        currentRow++
                    );
                }

                if (show(apptClient?.state?.name)) {
                    addSectionRow(apptClient.state.name, '', currentRow++);
                }

                currentRow += 1;

                worksheet.getCell(currentRow, 1).value = '#';
                worksheet.getCell(currentRow, 2).value = 'Description';
                worksheet.getCell(currentRow, 3).value = 'Appointment Number';
                worksheet.getCell(currentRow, 4).value = 'Cost';
                [1, 2, 3, 4].forEach(c => {
                    const cell = worksheet.getCell(currentRow, c);
                    cell.font = { bold: false, color: { argb: 'FFFFFFFF' }, size: 12 };
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF015969' } };
                });
                currentRow += 1;

                (apptClient?.appointments || []).forEach((val, index) => {
                    worksheet.getCell(currentRow, 1).value = index + 1;
                    worksheet.getCell(currentRow, 2).value = 'Appointment Number';
                    worksheet.getCell(currentRow, 3).value = val?.appid || `Appointment ${index + 1}`;
                    worksheet.getCell(currentRow, 4).value = `$${formatCurrency(val?.invoice?.total_amount)}`;
                    currentRow += 1;
                });

                worksheet.mergeCells(currentRow, 1, currentRow, 3);
                worksheet.getCell(currentRow, 1).value = 'Total Due';
                worksheet.getCell(currentRow, 1).font = { bold: true };
                worksheet.getCell(currentRow, 1).alignment = { horizontal: 'right' };
                worksheet.getCell(currentRow, 4).value = `$${formatCurrency(apptClient?.appointments?.reduce((sum, item) => sum + (item?.invoice?.total_amount || 0), 0))}`;
                worksheet.getCell(currentRow, 4).font = { bold: true };
                // worksheet.getCell('A6').value = 'Compressed Invoice';
                // worksheet.getCell('A6').font = { bold: true, size: 12 };
                // worksheet.getCell('A7').value = 'Appointment Number';
                // worksheet.getCell('B7').value = 'Total';
                // worksheet.getCell('A7').font = { bold: true };
                // worksheet.getCell('B7').font = { bold: true };

                // let currentRow = 8;
                // (apptClient?.appointments || []).forEach((val, index) => {
                //     worksheet.getCell(currentRow, 1).value = val?.appid || `Appointment ${index + 1}`;
                //     worksheet.getCell(currentRow, 2).value = `$${formatCurrency(val?.invoice?.total_amount)}`;
                //     currentRow += 1;
                // });

                // worksheet.getCell(currentRow, 1).value = 'Total Due';
                // worksheet.getCell(currentRow, 1).font = { bold: true };
                // worksheet.getCell(currentRow, 2).value = `$${formatCurrency(apptClient?.appointments?.reduce((sum, item) => sum + (item?.invoice?.total_amount || 0), 0))}`;
                // worksheet.getCell(currentRow, 2).font = { bold: true };
            } else {
                const addSectionRow = (label, value, rowIndex) => {
                    worksheet.getCell(rowIndex, 1).value = label;
                    worksheet.getCell(rowIndex, 2).value = value;
                };

                let currentRow = 5;
                worksheet.getCell(currentRow, 1).value = 'Bill To';
                worksheet.getCell(currentRow, 1).font = { bold: true, size: 12 };
                currentRow += 1;

            if (show(apptClient?.user?.name)) {
                addSectionRow(apptClient.user.name, '', currentRow);
                currentRow += 1;
            }
            if (show(apptClient?.billing_person)) {
                addSectionRow(apptClient.billing_person, '', currentRow);
                currentRow += 1;
            }
            if (show(apptClient?.billing_email)) {
                addSectionRow(apptClient.billing_email, '', currentRow);
                currentRow += 1;
            }
            if (show(apptClient?.billing_zipcode || apptClient?.city?.name)) {
                addSectionRow(`${apptClient?.billing_zipcode || ''} ${apptClient?.city?.name || ''}`.trim(), '', currentRow);
                currentRow += 1;
            }
            if (show(apptClient?.state?.name)) {
                addSectionRow(apptClient.state.name, '', currentRow);
                currentRow += 1;
            }

            currentRow += 1;
            // worksheet.getCell(currentRow, 1).value = 'Appointment Details';
            worksheet.getCell(currentRow, 1).font = { bold: true, size: 12 };
            currentRow += 1;

            // Table header row
            worksheet.getCell(currentRow, 1).value = '#';
            worksheet.getCell(currentRow, 2).value = 'Description';
            worksheet.getCell(currentRow, 3).value = 'Value';
            worksheet.getCell(currentRow, 4).value = 'Cost';
            [1, 2, 3, 4].forEach(c => {
                const cell = worksheet.getCell(currentRow, c);

                cell.font = {
                    bold: false,
                    color: { argb: 'FFFFFFFF' },
                    size: 12
                };

                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FF015969' }
                };
            });
            currentRow += 1;

            // const groupByConfig = getInvoiceGroupByConfig(apptClient?.appointments || [], apptClient?.invoice_group_by || '');
            const groupByConfig = getInvoiceGroupByConfig(apptClient?.invoice_group_by || '');
            const groupedAppointments = buildInvoiceGroups(apptClient?.appointments || [], groupByConfig.join(','));

        groupedAppointments.forEach((group) => {
            // if (groupByConfig.length > 0) {
            //     worksheet.getCell(currentRow, 1).value = group.label;
            //     worksheet.getCell(currentRow, 1).font = { bold: true };
            //     currentRow += 1;
            // }
            if (groupByConfig.length > 0) {
                worksheet.mergeCells(currentRow, 1, currentRow, 4);
                worksheet.getCell(currentRow, 1).value = group.label;
                // worksheet.getCell(currentRow, 1).font = { bold: true };
                currentRow += 1;
            }

            group.appointments.forEach((val, index) => {
                const totalHours = val?.invoice?.total_hours;
                const totalMinutes = totalHours
                    ? (parseInt(totalHours.split(':')[0], 10) * 60) + parseInt(totalHours.split(':')[1], 10)
                    : 0;
                const minDuration = val?.invoice?.min_duration;
                const minDurUnit = val?.invoice?.duration_unit;
                const minDurationMinutes = minDurUnit === 'hour' ? minDuration * 60 : minDuration;
                const isValid = totalMinutes >= minDurationMinutes;
                const inc = val?.invoice?.incremental;
                const incremental =
                    inc === '30_minute' ? '30 minute' :
                    inc === '1_hour' ? 'hourly' :
                    inc === 'minute' ? 'per minute' : null;

                const exceededTime = getExceededTime(
                    val.date,
                    val.end_time,
                    val.appointment_assign?.checkin_date,
                    val.appointment_assign?.checkout_time
                );
                const fullDuration = getFullDuration(
                    val.appointment_assign?.checkin_date,
                    val.appointment_assign?.checkin_time,
                    val.appointment_assign?.checkout_date,
                    val.appointment_assign?.checkout_time
                );
                // const hasCustomPricing = !!val?.appointment_custom_pricing;
                const customPricing = val?.appointment_custom_pricing;

                const hasCustomPricing =
                    Number(customPricing?.mileage_total || 0) > 0 ||
                    Number(customPricing?.travel_total || 0) > 0 ||
                    Number(customPricing?.discount || 0) > 0 ||
                    Number(val?.invoice?.rush_fee || 0) > 0;

                // worksheet.getCell(currentRow, 1).value = `${index + 1}. Appointment`;
                // worksheet.getCell(currentRow, 1).font = { bold: true };
                // currentRow += 1;
                const addSectionRow = (label, value, rowIndex) => {
                    worksheet.getCell(rowIndex, 2).value = label;
                    worksheet.getCell(rowIndex, 3).value = value;
                };
                const apptStartRow = currentRow;

                if (show(val?.appid)) {
                    addSectionRow('Appointment Number', val.appid, currentRow);
                    currentRow += 1;
                }
                if (show(val?.language?.name)) {
                    addSectionRow('Language', val.language.name, currentRow);
                    currentRow += 1;
                }
                if (show(val?.status) && val.status !== 'completed') {
                    addSectionRow('Status', val.status, currentRow);
                    currentRow += 1;
                }
                if (show(val?.date)) {
                    const timezone = val?.appointment_details?.timezone?.name;

                    let formattedDate = moment(val.date).format('DD/MM/YYYY');

                    if (timezone) {
                        const dateTime = moment.tz(
                            `${val.date} ${val.start_time || '00:00:00'}`,
                            'YYYY-MM-DD HH:mm:ss',
                            timezone
                        );

                        formattedDate = `${dateTime.format('DD/MM/YYYY')} (${dateTime.format('z')} / GMT${dateTime.format('Z')})`;
                    }
                    addSectionRow('Date', formattedDate, currentRow);
                    // addSectionRow('Date', `${moment(val.date).format('DD/MM/YYYY')} (${val?.appointment_details?.timezone?.abbreviation || ''} / GMT${val?.appointment_details?.timezone?.utc_offset || ''})`.trim(), currentRow);
                    currentRow += 1;
                }
                if (show(val?.type)) {
                    const minDurationText = minDuration ? ` (min duration: ${minDuration} ${minDurUnit || ''})`.trim() : '';
                    addSectionRow('Modality', `${val.type}${minDurationText ? ' ' + minDurationText : ''}`, currentRow);
                    // addSectionRow('Modality', val.type, currentRow);
                    currentRow += 1;
                }
                if (show(val?.subject)) {
                    addSectionRow('Type', val.subject + (incremental ? ` (Incremental: ${incremental})` : ''), currentRow);
                    currentRow += 1;
                }
                if (show(val?.start_time) && show(val?.date)) {
                    const scheduledCrossesMidnight = val?.end_time &&
                        moment(val.end_time, 'HH:mm:ss').isBefore(moment(val.start_time, 'HH:mm:ss'));

                    if (scheduledCrossesMidnight) {
                        addSectionRow(
                            'Scheduled Start Date Time',
                            `${moment(val.date).format('DD/MM/YYYY')} ${moment(val.start_time, 'HH:mm:ss').format('h:mm A')}`,
                            currentRow
                        );
                    } else {
                        addSectionRow('Scheduled Start Time', moment(val.start_time, 'HH:mm:ss').format('h:mm A'), currentRow);
                    }
                    currentRow += 1;
                } else if (show(val?.start_time)) {
                    addSectionRow('Scheduled Start Time', moment(val.start_time, 'HH:mm:ss').format('h:mm A'), currentRow);
                    currentRow += 1;
                }
                if (show(val?.estimated_duration)) {
                    addSectionRow('Scheduled Duration', `${val?.estimated_duration} ${val?.estimated_duration_unit}`, currentRow);
                    currentRow += 1;
                }
                const actualStart = renderActualStartTime(
                    val?.appointment_assign?.checkin_date,
                    val?.appointment_assign?.checkin_time,
                    val?.appointment_assign?.checkout_date,
                    val?.appointment_assign?.checkout_time
                );
                if (actualStart) {
                    addSectionRow(actualStart.label, actualStart.value, currentRow);
                    currentRow += 1;
                }
                if (fullDuration) {
                    addSectionRow('Actual Duration', fullDuration, currentRow);
                    currentRow += 1;
                }
                if (fullDuration) {
                    addSectionRow('Total Billable Duration', `${val?.invoice?.extra_duration || 0} minute`, currentRow);
                    currentRow += 1;
                }
                if (show(val?.invoice?.rate)) {
                    addSectionRow('Rate', `$${val.invoice.rate}/${val.invoice.rate_unit || ''}`, currentRow);
                    currentRow += 1;
                }
                if (val?.invoice?.rush_fee > 0) {
                    addSectionRow('Rush Fee', `$${val.invoice.rush_fee}`, currentRow);
                    currentRow += 1;
                }
                if (show(val?.appointment_details?.facility?.facility_name)) {
                    addSectionRow('Facility Name', val.appointment_details.facility.facility_name, currentRow);
                    currentRow += 1;
                }
                if (show(val?.appointment_details?.requester_name)) {
                    addSectionRow('Requestor Name', val.appointment_details.requester_name, currentRow);
                    currentRow += 1;
                }
                if (show(val?.appointment_details?.requester_email)) {
                    addSectionRow('Requestor Email', val.appointment_details.requester_email, currentRow);
                    currentRow += 1;
                }
                if (show(val?.appointment_details?.requester_phone)) {
                    addSectionRow('Requestor Phone', val.appointment_details.requester_phone, currentRow);
                    currentRow += 1;
                }
                if (show(val?.interpreter && `${val.interpreter.id}`)) {
                    addSectionRow('Vendor Id', `${val.interpreter.id}`, currentRow);
                    currentRow += 1;
                }
                if (show(val?.interpreter && `${val.interpreter.first_name} ${val.interpreter.last_name}`)) {
                    addSectionRow('Vendor Name', `${val.interpreter.first_name} ${val.interpreter.last_name}`, currentRow);
                    currentRow += 1;
                }
                if (show(val?.appointment_assign?.comments)) {
                    addSectionRow('Comments', val.appointment_assign.comments, currentRow);
                    currentRow += 1;
                }

                const dynamicFieldsList = (() => {
                    try {
                        const parsed = val?.appointment_details?.dynamic_fields
                            ? JSON.parse(val.appointment_details.dynamic_fields)
                            : [];
                        return Array.isArray(parsed) ? parsed.filter(f => f?.show_in_invoice === true) : [];
                    } catch {
                        return [];
                    }
                })();

                if (dynamicFieldsList.length > 0) {
                    addSectionRow('Extra Fields', '', currentRow);
                    worksheet.getCell(currentRow, 2).font = { bold: true };
                    currentRow += 1;

                    dynamicFieldsList.forEach((f) => {
                        if (f?.value) {
                        addSectionRow(f?.name || '', f?.value || '', currentRow);
                        currentRow += 1;
                        }
                    });
                }

                if (val?.invoice) {
                    // const hasCustomPricing = !!val?.appointment_custom_pricing;
                    if (hasCustomPricing) {
                        addSectionRow('Cost Breakdown', '', currentRow);
                        worksheet.getCell(currentRow, 2).font = { bold: true };
                        currentRow += 1;
                        addSectionRow('Rate', `$${val?.invoice?.rate}/${val.invoice.rate_unit || ''} × ${val?.invoice?.extra_duration || 0} minutes`, currentRow);
                        currentRow += 1;
                        if (val?.appointment_custom_pricing?.mileage_total > 0) {
                            addSectionRow('+ Mileage Total', `$${val.appointment_custom_pricing.mileage_total}`, currentRow);
                            currentRow += 1;
                        }
                        if (val?.appointment_custom_pricing?.travel_total > 0) {
                            addSectionRow('+ Travel Total', `$${val.appointment_custom_pricing.travel_total}`, currentRow);
                            currentRow += 1;
                        }
                        // if ((val?.appointment_custom_pricing?.sub_total > 0 && val?.appointment_custom_pricing?.discount > 0)) {
                        //     addSectionRow('= Sub Total', `$${val.appointment_custom_pricing.sub_total}`, currentRow);
                        //     currentRow += 1;
                        // }
                        if (val?.appointment_custom_pricing?.discount > 0) {
                            addSectionRow('+ Discount', `${val.appointment_custom_pricing.discount}%`, currentRow);
                            currentRow += 1;
                        }
                        if (val?.invoice?.rush_fee > 0) {
                            addSectionRow('+ Rush Fee', `$${val.invoice.rush_fee}`, currentRow);
                            currentRow += 1;
                        }
                        addSectionRow('= Total Cost', `$${formatCurrency(val?.invoice?.total_amount)}`, currentRow);
                        currentRow += 1;
                    } else {
                        addSectionRow('Total Cost', `$${formatCurrency(val?.invoice?.total_amount)}`, currentRow);
                        currentRow += 1;
                    }
                }

                // if (exceededTime) {
                //     addSectionRow('Exceeded Time', exceededTime, currentRow);
                //     currentRow += 1;
                // }

                // if (isValid === false || incremental) {
                //     addSectionRow('Incremental', incremental || '', currentRow);
                //     currentRow += 1;
                // }

                const apptEndRow = currentRow - 1;
                if (apptEndRow >= apptStartRow) {
                    if (apptEndRow > apptStartRow) {
                        worksheet.mergeCells(apptStartRow, 1, apptEndRow, 1);
                        worksheet.mergeCells(apptStartRow, 4, apptEndRow, 4);
                    }
                    worksheet.getCell(apptStartRow, 1).value = index + 1;
                    worksheet.getCell(apptStartRow, 1).alignment = { vertical: 'top', horizontal: 'left' };

                    worksheet.getCell(apptStartRow, 4).value = `$${formatCurrency(val?.invoice?.total_amount)}`;
                    worksheet.getCell(apptStartRow, 4).alignment = { vertical: 'top', horizontal: 'left' };
                }

                currentRow += 1;
            });
        });

                // worksheet.getCell(currentRow, 1).value = 'Total Due';
                // worksheet.getCell(currentRow, 1).font = { bold: true };
                // worksheet.getCell(currentRow, 2).value = `$${formatCurrency(apptClient?.appointments?.reduce((sum, item) => sum + (item?.invoice?.total_amount || 0), 0))}`;
                // worksheet.getCell(currentRow, 2).font = { bold: true };

                worksheet.mergeCells(currentRow, 1, currentRow, 3);
                worksheet.getCell(currentRow, 1).value = 'Total Due';
                worksheet.getCell(currentRow, 1).alignment = { horizontal: 'right' };
                worksheet.getCell(currentRow, 4).value = `$${formatCurrency(apptClient?.appointments?.reduce((sum, item) => sum + (item?.invoice?.total_amount || 0), 0))}`;
            }

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = `${invoiceNumber || 'invoice'}.xlsx`;
            anchor.click();
            window.URL.revokeObjectURL(url);

            if (onComplete) onComplete();
        } catch (error) {
            console.error('Unable to generate Excel invoice', error);
            toast.error('Unable to generate Excel invoice', {
                className: 'errorToast',
            });
        }
    };

    const submitCallback = (status, message, pdf, invoice) => {
        if (status) {
        const afterDownload = () => {
            toast.success(message, {
                className: "successToast",
            });
            dispatch(fetchGeneratedInvoices());
            setButtonLoader(false);
            navigate('/invoices');
        };
        if (selectedDownloadFormat.current === 'pdf') {
            if (pdf) {
                const link = document.createElement('a');
                link.href = `data:application/pdf;base64,${pdf}`;
                link.download = `${invoice.invoice_number}.pdf`;
                link.click();
                afterDownload();
            } else {
                handleGeneratePdf(afterDownload);
            }
        } else if (selectedDownloadFormat.current === 'excel') {
            handleGenerateExcel(afterDownload);
        }else {
            setButtonLoader(false);
            toast.error(message, {
                className: "errorToast",
            });
        }
            // toast.success(message, {
            //     className: "successToast",
            // })
            // dispatch(fetchGeneratedInvoices());
            // setButtonLoader(!status);
            // navigate(-1)
            // navigate('/invoices');
        }
        else {
        setButtonLoader(false);
            toast.error(message,
                {
                    className: "errorToast",
                }
            );
        }
    };

    const handleSaveInvoice = async () => {
        const format = await promptDownloadFormat();
        if (!format) {
            return;
        }

        setButtonLoader(true)
        selectedDownloadFormat.current = format;
        if (!apptClient) return;
        const totalAppt = apptClient.appointments?.length || 0;
        const appointmentIds = apptClient.appointments?.map(a => a.id) || [];
        const invoiceData = {
            client_id: id,
            invoice_number: invoiceNumber,
            total_appointments: totalAppt,
            total_due_bill: totalDueBill,
            invoice_type: invoiceType,
            appointment_ids: appointmentIds,
        };
        dispatch(makeInvoice(invoiceData, submitCallback));
    }

    const promptDownloadFormat = async () => {
        const result = await Swal.fire({
            title: 'Save Invoice',
            text: 'Choose the file format you want to download.',
            showDenyButton: true,
            confirmButtonText: 'Download PDF',
            denyButtonText: 'Download Excel',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
            customClass: {
                denyButton: 'swal-btn',
                confirmButton: 'swal-btn',
            },
        });

        if (result.isConfirmed) {
            return 'pdf';
        }

        if (result.isDenied) {
            return 'excel';
        }

        return null;
    };


    return (
        <div className="content">
            {!isInvoiceExist &&
                <div className='row_savebtn'>
                    <div className='d-flex align-items-center gap-2'>
                        <button className="main_heading back_button" onClick={() => navigate(-1)}>
                            <i className="fa-solid fa-arrow-left"></i> Back
                        </button>
                    </div>
                    <SubmitButton
                        handleSubmit={handleSaveInvoice}
                        buttonType={'button'}
                        loader={buttonLoader}
                        btnText={'Save Invoice'}
                    />
                </div>
            }
            <div ref={invoiceRef} className='view_pdf_main'>
                <PdfForm data={apptClient} invoiceNumber={invoiceNumber} totalDueBill={totalDueBill} loader={loader} type={invoiceType}/>
            </div>
        </div>
    );
};

export default PdfView;
